import * as Rest from 'src/constants/rest'
import { AvisoLexnet } from 'src/interfaces'
import http from 'src/utils/Http'

export function getAvisosLexnet(isNew: boolean | null = null): Promise<AvisoLexnet[]> {
  const url =
    isNew === null
      ? Rest.AVISOS_LEXNET
      : `${Rest.AVISOS_LEXNET}?${new URLSearchParams({ isNew: isNew ? '1' : '0' }).toString()}`
  return http.get({
    url,
    token: true
  })
}

export function markAsRead(id: string | number): Promise<AvisoLexnet> {
  return http.post({
    url: Rest.AVISO_LEXNET_MARK_AS_READ(id),
    token: true,
    params: {}
  })
}
